import {
  DAY_SUMMARY_LIST_ALL,
  DAY_SUMMARY_LIST_GET,
  DAY_SUMMARY_LIST_PUT,
  DAY_SUMMARY_LIST_POST,
  DAY_SUMMARY_LIST_LOADING,
  DAY_SUMMARY_LIST_ERROR,
} from '../types';

import api from '../../../utils/functions/api';

export const daySummaryListCreate = (payload) => async (dispatch) => {
  try {
    dispatch({ type: DAY_SUMMARY_LIST_LOADING });
    const { data } = await api.post(
      `${process.env.REACT_APP_API_URL}/day-summarylist`,
      {
        ...payload,
      },
    );
    dispatch({ type: DAY_SUMMARY_LIST_POST, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: DAY_SUMMARY_LIST_ERROR });
    throw new Error(error);
  }
};

export const daySummaryListAll =
  (params = {}) =>
  async (dispatch) => {
    try {
      const { name = '', size = null, page = 1 } = params;
      const { data, status } = await api.get(
        `${process.env.REACT_APP_API_URL}/day-summarylist`,
      );
      if (status === 200) {
        dispatch({ type: DAY_SUMMARY_LIST_ALL, payload: data });
      }
    } catch (error) {
      console.error(error);
      dispatch({ type: DAY_SUMMARY_LIST_ERROR });
      throw new Error(error);
    }
  };

export const daySummaryListGet = (id) => async (dispatch) => {
  try {
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/day-summarylist/${id}`,
    );
    if (status === 200) {
      dispatch({ type: DAY_SUMMARY_LIST_GET, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: DAY_SUMMARY_LIST_ERROR });
    throw new Error(error);
  }
};

export const daySummaryListPut = (id, payload) => async (dispatch) => {
  try {
    dispatch({ type: DAY_SUMMARY_LIST_LOADING });
    const { data } = await api.put(
      `${process.env.REACT_APP_API_URL}/day-summarylist/${id}`,
      payload,
    );
    dispatch({ type: DAY_SUMMARY_LIST_PUT, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: DAY_SUMMARY_ERROR });
    throw new Error(error);
  }
};
